import { attach, createEffect } from 'effector';

import { baseUrls$ } from 'model/config.model';
import { captureErrorFx } from 'model/helpers/analytics.model';
import { sessionToken$, applicationKey$ } from 'model/session.model';
import { request, RequestException, RequestParams } from 'libs/request';

export type ApiException<T = {}> = {
	error: true;
	error_code: string[];
} & T

export const requestFx = attach({
	effect: createEffect<RequestParams, any, RequestException<ApiException>>({
		handler: request,
	}),
	source: {
		baseUrls: baseUrls$,
		sessionToken: sessionToken$,
		applicationKey: applicationKey$,
	},
	mapParams: (params: RequestParams, source) => {
		const headers = params.headers || {
			'hive-session-token': source.sessionToken,
			'hive-application-key': source.applicationKey,
		};

		return {
			baseUrl: source.baseUrls.apiBaseUrl,
			...params,
			headers: {
				...headers,
			},
		};
	},
});

requestFx.fail.watch((payload) => {
	captureErrorFx(payload.error);
});

export const http = {
	get: attach({
		effect: requestFx,
		mapParams(params: RequestParams) {
			return {
				...params,
				method: 'get',
			};
		},
	}),
	post: attach({
		effect: requestFx,
		mapParams(params: RequestParams) {
			return {
				...params,
				method: 'post',
			};
		},
	}),
	patch: attach({
		effect: requestFx,
		mapParams(params: RequestParams) {
			return {
				...params,
				method: 'patch',
			};
		},
	}),
};
